var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preview-share-email" },
    [
      _vm.loading
        ? _c("email-preview-modal-loader")
        : [
            _c("p", [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t(
                      "application.messages.onlyMainApplicationEmailPreview"
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "embed-responsive embed-responsive-16by9" },
              [
                _c("iframe", {
                  staticClass: "embed-responsive-item",
                  attrs: { srcdoc: _vm.previewEmail, allowfullscreen: "" },
                }),
              ]
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }